<template>
    <v-container grid-list-md>
        <v-layout row wrap>
            <v-flex xs12>
                <v-img src="static/careerBg.jpg" max-height="380px"></v-img>
            </v-flex>
            <v-flex xs12 md8 v-if="showMsg">
                <v-card>
                    <v-card-title class="px-0">
                        <h2>We Are Hiring!</h2>
                    </v-card-title>
                    <v-card-text>
                        <p>
                            The rapidly growing accounting firm is looking for assistants/interns. The ideal candidates
                            will work closely with Associates during tax season and get to handle many
                            individual/business returns.

                            <!-- Qualifications:<br/><br/>
                            The ideal candidates must possess the following qualifications: -->
                        </p>

                        <h4>Accountant</h4>
                        <p>
                        Worksite: Flushing, NY.<br/>

                        <strong>Duties:</strong>
                        </p>

                        <ol>
                          <li>Prepare and file business and individual tax returns, and ensure taxes are paid properly and on time</li>
                          <li>Assist senior accountant to examine clients' financial reporting processes, including account analysis and reconciliations.</li>
                          <li>Provide consulting service to client by reviewing and analyzing clients' financial operations to make recommendations.</li>
                          <li>Assist to inspect client's account books and accounting systems, and provide bookkeeping services.</li>
                          <li>Payroll service to business clients.</li>
                        </ol>

                        <br/>Requires: Bachelor's Degree in Accounting

                       <!-- <ul style="list-style: none" v-for="(qualification, i) in qualifications" :key="i">
                            <li>{{i+1}}. {{qualification}}</li>
                        </ul> -->
                        <br/>
                        <p>Please only reply if you meet all the listing qualifications. Click this button <NewCandidate/> to update your
                            for interview consideration. or mail resume and cover letter to: Prudent Accounting Services. LLC, 38-08 Union Street, Unit 2D, Flushing, NY 11354</p>

                        <p>
                            Prudent Accounting Services, LLC. is an Equal Opportunity/Affirmative Action employer. All
                            qualified applicants will receive consideration for employment without regard to race, age,
                            color, religion, sex, sexual orientation, gender identity, national origin, disability or
                            protected veteran status, or any other legally protected basis, in accordance with
                            applicable law.
                        </p>

                        <p>Best Regards,</p>
                        <p>Prudent Accounting Services, LLC</p>
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex xs12 md4>
                <CompanyContact/>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import CompanyContact from '@/components/common/CompanyContact'
    import NewCandidate from '@/components/career/dialog/NewCandidate'

    export default {
        name: "CareerHome",
        components: {
            CompanyContact, NewCandidate
        },
        data: () => ({
            resumeFile: '',
            showMsg: true,
            qualifications: [
                'Must have a Bachelor\'s Degree in Accounting, or Master\'s Degree in Accounting is preferred',
                'Must be working on obtaining a CPA license',
                'Have basic knowledge on Accounting and Federal Tax',
                'Must be a good team player',
                'Must be fluent in English and a secondary language'
            ]
        })
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/career/CareerHome.vue